import {Middleware, MiddlewareAPI} from "@reduxjs/toolkit";
import {clearData} from "../slices/data.slice";
import {TableFilterKey} from "../../model/filters/TableFiltersDefinitions";
import {updateFilterPage} from "../slices/filters.slice";

export const ClearCacheMiddleware: Middleware = (api: MiddlewareAPI) => (next) => (action) => {
    if (action.type.endsWith('/fulfilled') && action.meta?.arg?.type === 'mutation') {
        const url: string = action.meta.baseQueryMeta.request.url
        const method: string = action.meta.baseQueryMeta.request.method
        const dataType: null | TableFilterKey[] = getDataType(url, method)
        if (dataType) {
            dataType.forEach(type => {
                api.dispatch(clearData(type))
                api.dispatch(updateFilterPage({key: type, value: 0}))
            })
        }
    }
    return next(action)
}

function getDataType(url: string, method: string) {
    if (url.includes("guide")) {
        return null
    }
    if (url.includes("nomenclature") && !url.includes("attachment")) {
        return [TableFilterKey.NOMENCLATURE_GUIDE_FILTER]
    }
    if (url.includes("measurement-unit")) {
        return [TableFilterKey.MEASUREMENT_UNIT_GUIDE_FILTER]
    }
    if (url.includes("role")) {
        return [TableFilterKey.ADMINISTRATIVE_ROLE_GUIDE_FILTER]
    }
    if (url.includes("user")) {
        return [TableFilterKey.USER_GUIDE_FILTER]
    }
    if (url.includes("individual") && !url.includes("photo")) {
        return [TableFilterKey.INDIVIDUALS_GUIDE_FILTER]
    }
    if (url.includes("bill-of-materials") && !url.includes("/material") && !url.includes("stage") && !url.includes("step")) {
        if (url.includes("product")) {
            if (method === 'PUT') {
                return [TableFilterKey.TECHNOLOGICAL_PROCESS_CHART_GUIDE_FILTER]
            } else {
                return null
            }
        }
        return [TableFilterKey.TECHNOLOGICAL_PROCESS_CHART_GUIDE_FILTER]
    }
    if (url.includes("production-stage")) {
        return [TableFilterKey.PRODUCTION_STAGE_GUIDE_FILTER]
    }
    if (url.includes("technological-operation")) {
        return [TableFilterKey.TECHNOLOGICAL_OPERATION_GUIDE_FILTER]
    }
    if (url.includes("production-order")) {
        return [TableFilterKey.PRODUCTION_ORDER_EXECUTION_JOURNAL_FILTER, TableFilterKey.PRODUCTION_ORDER_JOURNAL_FILTER, TableFilterKey.PRODUCTION_ORDER_ANALYSIS_BY_TIME_FILTER]
    }
    if (url.includes("production-task")) {
        return [TableFilterKey.PRODUCTION_ORDER_EXECUTION_JOURNAL_FILTER, TableFilterKey.PRODUCTION_ORDER_JOURNAL_FILTER, TableFilterKey.PRODUCTION_ORDER_ANALYSIS_BY_TIME_FILTER]
    }
    if (url.includes("zone")) {
        return [TableFilterKey.ADMINISTRATIVE_AND_FUNCTIONAL_ZONE_GUIDE_FILTER]
    }
    return null
}